import React from 'react'
import { BaseCustomButton, BaseCustomModal, GradientDecorationLine } from '../../shared';

export const TableItemDeleteModal = ({ setShowModal, showModal, modalHeader, modalBodyLabel, onDeleteConfirmation, icon }) => {

    const onDelete = () => {
        onDeleteConfirmation();
        setShowModal(false);
    };

    const handleCancel = () => {
        setShowModal(false);
    };

    const modalTitle = icon === 'warning' 
    ? (
        <div className='d-flex align-items-center'>
            <span className="mdi mdi-alert-outline mdi-36px text-warning"></span>
            <h4 className='text-primary m-0 ps-3'>{modalHeader}</h4>
        </div>
    )
    : <h4 className='text-primary ps-3 m-0'>{modalHeader}</h4>;

    const children_body = (
        <div className="px-4">
            <label className='text-primary '>{modalBodyLabel}</label>
            <br />
        </div>
    );

    const buttons = (
        <div className="page-title-box d-flex justify-content-end">
            <BaseCustomButton
                color="danger"
                label="Eliminar"
                onClick={onDelete}
                outline
                className="rounded-3 me-3 p-2"
                icon="mdi mdi-delete me-1"
            />
            <BaseCustomButton
                color="primary"
                label="Cancelar"
                onClick={handleCancel}
                outline
                className="rounded-3 p-2"
                icon="mdi mdi-close-circle me-1"
            />
        </div>
    );

    return (
        <BaseCustomModal
            title={modalTitle}
            isModalOpen={showModal}
            handleOk={onDelete}
            handleCancel={handleCancel}
            footer={null}
        >
            <GradientDecorationLine />
            {children_body}
            <GradientDecorationLine />
            {buttons}
        </BaseCustomModal>
    )
}

